import { TranslationKeys } from '~/common/types';

export const ENTITY_CONTACT_TYPE_LOOKUP: Record<string, keyof TranslationKeys> =
  {
    LOGISTICS_CONTACT: 'app.entity.contact.type.logistics_contact',
    ORDERS_CONTACT: 'app.entity.contact.type.orders_contact',
    QUOTES_CONTACT: 'app.entity.contact.type.quotes_contact',
    REDISTRIBUTION_CONTACT: 'app.entity.contact.type.redistribution_contact',
  };
